module.exports = __webpack_public_path__ + "img/data-sheets.d99676a0.svg";